import { getPublicRestClient, getRestClient } from "../client";
import { CustomerCommunicationSearch, OrderResponse } from "../graphql/generated/generated";
export interface CreateOrderInput {
  payload: string;
  payment: string;
  currency: string;
  webhookUrl?: string;
  shippingClassification: string;
  destination: {
    name: string;
    company: string;
    address1: string;
    address2: string;
    address3: string;
    city: string;
    state: string;
    postal: string;
    country: string;
    phone: string;
    email: string;
  };
  orderItems: Array<{
    sku: string;
    quantity: number;
    retailPrice: string;
    itemDescription: string;
    product: {
      coverUrl: string;
      gutsUrl: string;
      pageCount: string | number;
    };
  }>;
}

export interface CreateOrderResponse {
  customerOrderId: string;
  statusCode: number;
  statusDescription: string;
}

export const exportCommunicationsCSV = async (body: CustomerCommunicationSearch, authHeader: string) => {
  return getPublicRestClient().post<Blob>("/internal/openapi-backend/admin/export/customerCommunications", body, {
    headers: {
      Authorization: authHeader,
    },
    responseType: "blob",
  });
};

export const createOrder = async (body: CreateOrderInput, authHeader: string) => {
  return getRestClient().post<CreateOrderResponse>("/orders/create", body, {
    headers: {
      Authorization: authHeader,
    },
  });
};

export const getOrderById = async (customerOrderId: string, authHeader: string) => {
  return getRestClient().get<Omit<OrderResponse, "__typename">>("/orders/" + customerOrderId, {
    headers: {
      Authorization: authHeader,
    },
  });
};
